import React, { useState } from 'react';
import './Navigation.css';

const Navigation = ({ scrollToSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLinkClick = (section) => {
    scrollToSection(section);
    setMenuOpen(false); // Close menu after clicking
  };
  return (
    <nav className="navbar">
      <h1 className="company-name">Latha Studios</h1>
      <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>
      <ul className={`nav-links ${menuOpen ? 'nav-links--open' : ''}`}>
        <li><button type="button" onClick={() => handleLinkClick('home')}>Home</button></li>
        <li><button type="button" onClick={() => handleLinkClick('about')}>About</button></li>
        <li><button type="button" onClick={() => handleLinkClick('services')}>Services</button></li>
        <li><button type="button" onClick={() => handleLinkClick('gallery')}>Gallery</button></li>
        <li><button type="button" onClick={() => handleLinkClick('carousel')}>Packages</button></li>
        <li><button type="button" onClick={() => handleLinkClick('contact')}>Contact</button></li>
      </ul>
    </nav>
  );
};

export default Navigation;



























